import React, { useState, useEffect } from 'react';
import apiConfig from '../config/apiConfig';
import './Home.css';

const Home = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        setLoading(true);
        const response = await fetch(apiConfig.announcements, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'include'
        });
        
        if (!response.ok) {
          throw new Error('Failed to fetch announcements');
        }
        
        const data = await response.json();
        setAnnouncements(data);
      } catch (err) {
        console.error('Error fetching announcements:', err);
        setError('Failed to load announcements');
      } finally {
        setLoading(false);
      }
    };

    fetchAnnouncements();
  }, []);

  return (
    <div className="page-content home-page">
      <header className="hero-section">
        <h1>Welcome to <span className="highlight">Legacy Reborn</span></h1>
        <div className="intro-text">
          <p>A text-based RPG where your choices shape your destiny. Train skills, complete quests, create guilds, control cities, and build your legacy.</p>
        </div>

      </header>

      <section className="announcements-section">
        <div className="section-header">
          <h2>Latest Announcements</h2>
          <div className="section-decoration"></div>
        </div>
        
        {loading && <div className="loading-indicator">Loading announcements...</div>}
        
        {error && <div className="error-display">{error}</div>}
        
        {!loading && !error && announcements.length === 0 && (
          <div className="no-announcements">No announcements at this time.</div>
        )}
        
        {!loading && !error && announcements.length > 0 && (
          <div className="announcements-container">
            {announcements.map(announcement => (
              <div key={announcement.id} className="card announcement-card">
                <div className="announcement-date">
                  {new Date(announcement.date).toLocaleDateString(undefined, {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </div>
                <h3>{announcement.title}</h3>
                <p>{announcement.content}</p>
              </div>
            ))}
          </div>
        )}
      </section>

      <section className="features-section">
        <div className="section-header">
          <h2>Game Features</h2>
          <div className="section-decoration"></div>
        </div>

        <div className="features-container">
          <div className="feature-category">
            <h3 className="complete">Completed Features</h3>
            <div className="feature-card complete">
              <div className="feature-icon">💬</div>
              <div className="feature-content">
                <h4>Real-time Chat</h4>
                <p>Talk to other players, form alliances, and share your adventures in our global chat system.</p>
              </div>
            </div>
            <div className="feature-card complete">
              <div className="feature-icon">🔍</div>
              <div className="feature-content">
                <h4>Character Search</h4>
                <p>Find and view profiles of other players in the game world.</p>
              </div>
            </div>
          </div>

          <div className="feature-category">
            <h3>Coming Soon</h3>
            <div className="feature-card">
              <div className="feature-icon">⚔️</div>
              <div className="feature-content">
                <h4>Deeds System</h4>
                <p>Level up your character, alter your alignment, and earn gold through the deeds you perform.</p>
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📚</div>
              <div className="feature-content">
                <h4>Training</h4>
                <p>Hone your skills in Jailbreaking, Assassinations, Guild Ownership, and much more.</p>
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🧩</div>
              <div className="feature-content">
                <h4>Quests</h4>
                <p>Join questing groups and earn rewards as a team. Your decisions matter!</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="roadmap-section">
        <div className="section-header">
          <h2>Development Roadmap</h2>
          <div className="section-decoration"></div>
        </div>
        <div className="roadmap-timeline">
          <div className="timeline-item">
            <div className="timeline-marker complete"></div>
            <div className="timeline-content">
              <h4>Phase 1: Foundation</h4>
              <ul>
                <li>User registration and authentication</li>
                <li>Character creation</li>
                <li>Global chat system</li>
              </ul>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-marker current"></div>
            <div className="timeline-content">
              <h4>Phase 2: Core Gameplay</h4>
              <ul>
                <li>Deeds system</li>
                <li>Skills and training</li>
                <li>Basic quests</li>
                <li>City exploration</li>
              </ul>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-marker"></div>
            <div className="timeline-content">
              <h4>Phase 3: Social Features</h4>
              <ul>
                <li>Direct messaging</li>
                <li>Friends system</li>
                <li>Partnering</li>
                <li>Guilds</li>
              </ul>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-marker"></div>
            <div className="timeline-content">
              <h4>Phase 4: Advanced Features</h4>
              <ul>
                <li>City control</li>
                <li>Guild raids</li>
                <li>Banking system</li>
                <li>Casino</li>
                <li>Tournaments</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="join-community">
        <h2>Join Our Community Today</h2>
        <p>Begin your adventure and forge your own path in the world of Legacy Reborn!</p>
      </section>
    </div>
  );
};

export default Home;
